import { render, staticRenderFns } from "./ApprovalModal.vue?vue&type=template&id=bd11bb82&"
import script from "./ApprovalModal.vue?vue&type=script&lang=js&"
export * from "./ApprovalModal.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports